module.exports = __webpack_public_path__ + "img/morokhov.b2ae2d70.jpg";